import { AppConfigModel } from "../../abstract/app-config.model";

export class LoanEarlyRepaymentMode extends AppConfigModel {

    static override CLASS_NAME: string = 'LoanEarlyRepaymentMode';
}
